module.exports = [{"id":0,"title":"העשור הראשון","years":"1957-1948"},{"id":1,"title":"העשור השני","years":"1967-1958"},{"id":2,"title":"העשור השלישי","years":"1977-1968"},{"id":3,"title":"העשור הרביעי","years":"1987-1978"},{"id":4,"title":"העשור החמישי","years":"1997-1988"},{"id":5,"title":"העשור השישי","years":"2007-1998"},{"id":6,"title":"העשור השביעי","years":"2018-2008"}]


//////////////////
// WEBPACK FOOTER
// ./src/api/decades.json
// module id = 31
// module chunks = 0